import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { BuyerInfo, IDType, IDTypes, PSRole, PvtSellRequest, PvtSellResponse, RemoteDocument } from "../../../apis/privatesell/enitites";
import { Redirect } from "react-router";
import BuyerInfoDetail from "./BuyerInfo";
import { privateSellApi, privateSellService } from "../../../apis/privatesell";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import DocInfo from "./DocInfo";
import CheckBoxField from "@eres/forms-web/CheckBoxField";
import { defaultErrorManager } from "@eres/forms/errormanager";
import StateHolder from "@eres/forms/StateHolder";
import { showTerms } from "../../../apis/privatesell/api";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import AcceptRequestSuccess from "../Component/AcceptRequestSuccess";
import { JQModal } from "@my-dld/components/Popup/Utils";
import PrivateSellHeader from "../Component/PrivateSellHeader";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";

interface Props extends RoutedViewProps {

}

interface State {
	request?: PvtSellRequest;
	buyerInfo?: BuyerInfo;
	IdType: IDType;
	isAgreed: boolean;
}

export default class AcceptRequest extends Component<Props, State> {
	buyerInfoDetailForm: BuyerInfoDetail | null | undefined;
	buyerPhotosForm: DocInfo | null | undefined;

	constructor( props: Props ) {
		super( props );
		const state = props.location.state;
		this.state = {
			request: state ? state.request : undefined,
			buyerInfo: state ? state.buyerInfo : undefined,
			IdType: state && state.buyerInfo ? state.buyerInfo.emiratesId != undefined ? IDTypes[ 0 ] : IDTypes[ 1 ] : IDTypes[ 0 ],
			isAgreed: false,
		};
	}

	render() {
		const { request, buyerInfo, IdType } = this.state;
		if ( !request ) {
			// this.props.history.goBack();
			// let currentPath = getCurrentPath() as string;
			// const parsed = currentPath.substring(currentPath.lastIndexOf('/') + 1)
			// let path = getParentPath(currentPath, parsed);
			// debugger;
			return <Redirect to={ "/" }/>;
		}
		return <PrivateSellHeader role={ PSRole.BUYER } request={ request! }>
			<BuyerInfoDetail readonly={ false } ref={ ( ref ) => this.buyerInfoDetailForm = ref } buyerInfo={ buyerInfo } IdType={ IdType }>
			</BuyerInfoDetail>
			<DocInfo IdType={ IdType } ref={ ( ref ) => this.buyerPhotosForm = ref }/>
			<div className="d-flex pb-2">
				<CheckBoxField
					errorManager={ defaultErrorManager }
					holder={ StateHolder.buildStateHolder( this ) }
					id={ "isAgreed" }
					label={ Strings.i_agree_to_the }
					/>
				<a className="btn-link ms-1" onClick={ this.onShowTerms }>{ Strings.terms_and_conditions }</a>
			</div>
			<div>
				<button onClick={ this.onValidate } className="btn btn_1 btn_style1" type="submit">
					{ Strings.submit_label }
				</button>
				<a onClick={ this.backToPage } className="btn btn-grey btn_style1 ms-2 me-2">{ Strings.close_label }</a>
			</div>
			<AcceptRequestSuccess
				transaction={ this.state.request! }
				onDismiss={ this.onSuccessDismiss }/>
		</PrivateSellHeader>;
	}

	backToPage = () => {
		this.props.history.goBack();
		// if(this.state.enocModel.mode === Mode.EDIT || this.state.enocModel.mode === Mode.VIEW) {
		//     navigate("/mydld/my_requests");
		// } else {
		//     const property = this.props.getTabuProperty();
		//     replaceNavigate("/mydld/" + "property/" + property.propertyTypeId + "/" + property.tabuPropertyId);
		// }
	};

	onValidate = () => {
		let isValid = true;
		isValid = isValid && this.buyerInfoDetailForm != null && this.buyerInfoDetailForm.isValid();
		isValid = isValid && this.buyerPhotosForm != null && this.buyerPhotosForm.isValid();
		if ( isValid ) {
			if ( this.state.isAgreed ) {
				this.submitRequest();
			} else {
				showMessage( Strings.tc_error_msg );
			}
		}
	};

	private onSuccessDismiss = () => {
		let response: PvtSellResponse = this.props.location.state.result;
		response.actions = [];
		replaceNavigate( "/" + this.state.request?.bookingRequestInfo.referenceNumber, undefined, {
			result: response,
			role: PSRole.BUYER,
		} );
		JQModal( "AcceptRequestSuccessPopup" ).hide();
	};

	private onShowTerms = () => {
		this.setState( {
			isAgreed: true,
		}, showTerms );
	};

	private submitRequest() {
		let { request } = this.state;
		if ( request ) {
			showLoading();
			const buyerInfo: Partial<BuyerInfo> | undefined = this.buyerInfoDetailForm?.getData();
			privateSellService.uploadDocs( this.buyerPhotosForm?.getData().documents! ).then( ( docs: RemoteDocument[] ) => {
				let requestNew: Partial<PvtSellRequest> = {
					...request,
					bookingRequestInfo: {
						...request && request.bookingRequestInfo ? request.bookingRequestInfo : undefined,
						buyerInfo: {
							...buyerInfo,
							documents: docs,
						},
					},
				};
				const apiHandler = ( response: any ) => {
					hideLoading();
					if ( response && response.request ) {
						trackEventWithData( "PrivateSell", "BuyerRequestAccept", { bookingRef: response.request.bookingRequestInfo!.referenceNumber + "" } );
						this.setState( { request: response.request }, () => {
							JQModal( "AcceptRequestSuccessPopup" ).show();
						} );
					}
				};
				const exHandler = ( exp: any ) => {
					hideLoading();
					showMessage( exp.message );
				};
				privateSellApi.acceptBookingRequest( requestNew as PvtSellRequest ).then( apiHandler ).catch( exHandler );
			} ).catch( exp => {
				hideLoading();
				showMessage( exp.message );
			} );
		}
	}
}
